var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"grey lighten-5"}},[_c('CardHeaderVulnerability',_vm._g({attrs:{"vuln":this.vuln}},_vm.$listeners)),_c('CardBodyVulnerability',{attrs:{"vuln":this.vuln}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }